import './App.css';
import { FaInstagram, FaTelegramPlane, FaGithub } from 'react-icons/fa';
import { useEffect, useState } from 'react';

function App() {
  const [f12Count, setF12Count] = useState(0);
  const [alertShown, setAlertShown] = useState(false);

  const projects = [
    {
      title: "Order Calculator",
      description: "군의 차수(Order) 계산기",
      url: "https://order-dusky.vercel.app/",
      color: "#667eea"
    },
    {
      title: "RSA Calculator",
      description: "RSA 암호화 알고리즘 계산기",
      url: "https://rsa-sigma.vercel.app/",
      color: "#f093fb"
    },
    {
      title: "Euler Phi Function",
      description: "오일러 파이 함수 계산기",
      url: "https://euler-pi-function.vercel.app/",
      color: "#4facfe"
    },
    {
      title: "Euclidean Algorithm",
      description: "유클리드 알고리즘 계산기",
      url: "https://euclid-algorithm.vercel.app/",
      color: "#43e97b"
    }
  ];

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === 'F12') {
        event.preventDefault();
        const newCount = f12Count + 1;
        setF12Count(newCount);
        
        if (newCount === 5) {
          setAlertShown(true);
          
          // 개발자 도구 열기 (브라우저 제한으로 인해 직접 열기는 어려움)
          console.log("%c🎯 이스터 에그 발견!", "color: #ff6b6b; font-size: 20px; font-weight: bold;");
          console.log("%c🔐 숨겨진 Flag를 찾아보세요!", "color: #4ecdc4; font-size: 16px;");
          console.log("%c📁 Flag 파일 위치: /flag.txt", "color: #45b7d1; font-size: 14px;");
          console.log("%c🔑 RSA 복호화 키: n=3233, e=17, d=2753", "color: #96ceb4; font-size: 14px;");
          console.log("%c💡 암호화된 Flag: 3106 1961 1496 3106 1961 1496", "color: #feca57; font-size: 14px;");
          console.log("%c🎮 더 많은 이스터 에그를 찾아보세요!", "color: #ff9ff3; font-size: 16px;");
          
          setF12Count(0);
        } else {
          alert(`F12 키를 ${5 - newCount}번 더 누르세요!`);
        }
      }
    };

    document.addEventListener('keydown', handleKeyPress);
    return () => document.removeEventListener('keydown', handleKeyPress);
  }, [f12Count]);

  return (
    <div className="App">
      <div className="container">
        <header className="header">
          <h1>🔐 암호수학 과제 모음</h1>
          <p>암호수학 관련 계산 도구들을 한 곳에서 확인하세요</p>
        </header>
        
        <main className="main">
          <div className="projects-grid">
            {projects.map((project, index) => (
              <a
                key={index}
                href={project.url}
                target="_blank"
                rel="noopener noreferrer"
                className="project-card"
                style={{ '--card-color': project.color }}
              >
                <div className="card-content">
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                  <div className="card-arrow">→</div>
                </div>
              </a>
            ))}
          </div>
        </main>
        
        <footer className="footer custom-footer">
          <div className="footer-inner">
            <div className="footer-title">BBIYAKYEE7</div>
            <div className="footer-desc">2025 © Copyright by BBIYAKYEE7, All rights reserved.<br />Made and serviced with React.js</div>
            <div className="footer-icons">
              <a href="https://instagram.com/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
              <a href="https://t.me/" target="_blank" rel="noopener noreferrer" aria-label="Telegram"><FaTelegramPlane /></a>
              <a href="https://github.com/" target="_blank" rel="noopener noreferrer" aria-label="GitHub"><FaGithub /></a>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default App;
